<!-- 美装材料 - 手机端详情 -->
<template>
  <div class="mobile-detail-container">
    <!-- 头部 -->
    <div class="mobile-header">
      <span class="back-btn" @click="goBack">‹ 返回</span>
      <h2>优房美装材料使用详情</h2>
      <span class="header-placeholder"></span>
    </div>

    <!-- 加载中 -->
    <div v-if="loading" class="loading-box">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <!-- 详情内容 -->
    <div v-else-if="newsData.ID" class="detail-content">
      <!-- 标题 -->
      <div class="detail-title">
        <h1>{{ newsData.TITLE }}</h1>
      </div>

      <!-- 内容 -->
      <div class="detail-body" v-html="newsData.CONTENT"></div>
    </div>

    <!-- 错误提示 -->
    <div v-else class="error-box">
      <div class="error-icon">⚠️</div>
      <p>{{ errorMsg || "数据加载失败" }}</p>
      <button class="retry-btn" @click="loadDetail">重新加载</button>
    </div>
  </div>
</template>

<script>
import axios from "@/common/axiosHttp.js";
import md5 from "js-md5";

export default {
  name: "NewsMobileDetail",
  data() {
    return {
      op: "adminNewsGlWap",
      newsData: {},
      loading: false,
      errorMsg: "",
      apiUrl: "https://www.youfanglianmai.com/ptmainApi" //"http://localhost:8996/ptmainApi" //"https://www.youfanglianmai.com/ptmainApi"
    };
  },
  created() {
    this.loadDetail();
  },
  methods: {
    // 手机端专用的post请求（不校验session）
    sendMobilePost(paramData) {
      return new Promise((resolve, reject) => {
        const paramJson = JSON.stringify(paramData);
        const Base64 = require("js-base64").Base64;
        const baseStr = Base64.encode(paramJson);
        const sendParam = {
          paramData: baseStr,
          mac: md5(baseStr + "trialSystem000000000001")
        };
        const paramBase64 = Base64.encode(JSON.stringify(sendParam));

        axios.post(this.apiUrl, paramBase64).then(
          response => {
            const data = response.data;
            // 手机端不校验session，直接返回数据
            resolve(data);
          },
          err => {
            console.error("请求失败", err);
            reject(err);
          }
        );
      });
    },

    // 格式化日期时间
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "";
      let str = dateTimeStr.toString().trim();

      // 如果已经格式化好的
      if (str.includes("-") && str.includes(":")) {
        return str;
      }

      // 处理 yyyyMMddHHmmss 格式（14位）
      if (/^\d{14}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        const hour = str.substring(8, 10);
        const minute = str.substring(10, 12);
        const second = str.substring(12, 14);
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      }

      // 处理 yyyyMMdd 格式（8位）
      if (/^\d{8}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        return `${year}-${month}-${day}`;
      }

      return str;
    },

    // 加载详情
    loadDetail() {
      const id = this.$route.query.id;
      if (!id) {
        this.errorMsg = "缺少参数ID";
        return;
      }

      this.loading = true;
      this.errorMsg = "";

      var busData = {
        ID: id
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "getDetail"
        },
        busData: busData
      };

      this.sendMobilePost(paramData)
        .then(data => {
          this.loading = false;
          if (!data.isSuccess) {
            this.errorMsg = data.msg || "加载失败";
            return;
          }
          this.newsData = data.content || {};
        })
        .catch(err => {
          this.loading = false;
          this.errorMsg = "网络错误，请重试";
          console.error("加载详情失败", err);
        });
    },

    // 返回
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
/* 移动端基础样式 */
.mobile-detail-container {
  min-height: 100vh;
  background: #f5f5f5;
}

/* 头部 */
.mobile-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-btn {
  cursor: pointer;
  padding: 5px;
  min-width: 60px;
}

.back-btn:active {
  opacity: 0.7;
}

.mobile-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
  text-align: center;
}

.header-placeholder {
  min-width: 60px;
}

/* 详情内容 */
.detail-content {
  background: white;
  margin: 15px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 标题 */
.detail-title {
  padding: 20px 20px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.detail-title h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  word-wrap: break-word;
}

/* 信息栏 */
.detail-info {
  padding: 12px 20px;
  background: #f9f9f9;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666;
}

.info-icon {
  margin-right: 5px;
  font-size: 14px;
}

/* 内容主体 */
.detail-body {
  padding: 20px;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* 富文本内容样式 */
.detail-body >>> p {
  margin: 15px 0;
  line-height: 1.8;
}

.detail-body >>> img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 15px 0;
  border-radius: 5px;
}

.detail-body >>> h1,
.detail-body >>> h2,
.detail-body >>> h3,
.detail-body >>> h4,
.detail-body >>> h5,
.detail-body >>> h6 {
  margin: 20px 0 15px;
  font-weight: 600;
  color: #333;
}

.detail-body >>> h1 {
  font-size: 24px;
}

.detail-body >>> h2 {
  font-size: 22px;
}

.detail-body >>> h3 {
  font-size: 20px;
}

.detail-body >>> h4 {
  font-size: 18px;
}

.detail-body >>> ul,
.detail-body >>> ol {
  margin: 15px 0;
  padding-left: 25px;
}

.detail-body >>> li {
  margin: 8px 0;
  line-height: 1.8;
}

.detail-body >>> blockquote {
  margin: 15px 0;
  padding: 10px 15px;
  background: #f9f9f9;
  border-left: 4px solid #667eea;
  color: #666;
}

.detail-body >>> code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: "Courier New", monospace;
  font-size: 14px;
}

.detail-body >>> pre {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 5px;
  overflow-x: auto;
  margin: 15px 0;
}

.detail-body >>> pre code {
  background: none;
  padding: 0;
}

.detail-body >>> table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
  overflow-x: auto;
  display: block;
}

.detail-body >>> table th,
.detail-body >>> table td {
  border: 1px solid #e0e0e0;
  padding: 10px;
  text-align: left;
}

.detail-body >>> table th {
  background: #f5f5f5;
  font-weight: 600;
}

.detail-body >>> a {
  color: #667eea;
  text-decoration: none;
}

.detail-body >>> a:active {
  opacity: 0.7;
}

/* 加载中 */
.loading-box {
  text-align: center;
  padding: 80px 0;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 10px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-box p {
  color: #999;
  font-size: 14px;
}

/* 错误提示 */
.error-box {
  text-align: center;
  padding: 80px 20px;
}

.error-icon {
  font-size: 60px;
  margin-bottom: 15px;
  opacity: 0.5;
}

.error-box p {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.retry-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 30px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.retry-btn:active {
  opacity: 0.8;
  transform: scale(0.98);
}

/* 响应式 */
@media (min-width: 768px) {
  .mobile-detail-container {
    max-width: 768px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newsGlIndex/NewsMobileDetail.vue